import { render, staticRenderFns } from "./DebossV3.vue?vue&type=template&id=be8e23f2"
import script from "./DebossV3.vue?vue&type=script&lang=js"
export * from "./DebossV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports